// dateTime変換モジュール
export const dateTimeModules = {
  // dateTime型→YYYYMMDDの文字列変換
  dateConvertToString (dateTime) {
    var strMonth = ('0' + (dateTime.getMonth() + 1)).slice(-2)
    var strDate = ('0' + dateTime.getDate()).slice(-2)
    return `${dateTime.getFullYear()}${strMonth}${strDate}`
  },
  // "YYYYMMDD hh:mm:ss"or"YYYYMMDD"の文字列をdateTime型に変換
  dateConvertToDate (strDateTime) {
    var strDate = `${strDateTime.substr(0, 4)}/${strDateTime.substr(4, 2)}/${strDateTime.substr(6, 2)}`
    if (strDateTime.length > 8) {
      var strTime = `${strDateTime.substr(8, 2)}:${strDateTime.substr(10, 2)}:${strDateTime.substr(12, 2)}`
      return new Date(`${strDate} ${strTime}`)
    } else {
      return new Date(`${strDate} 00:00:00`)
    }
  },
  // dateTime型→"YYYY-MM-DD"の文字列変換
  dateConvertToDateHyphen (dateTime) {
    var strMonth = ('0' + (dateTime.getMonth() + 1)).slice(-2)
    var strDate = ('0' + dateTime.getDate()).slice(-2)
    var strHyphenDate = `${dateTime.getFullYear()}-${strMonth}-${strDate}`
    return strHyphenDate
  }
}



// WEBPACK FOOTER //
// ./src/router/DataConvert.js